import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.maskingPolicies || initialState;

export const seletMaskingPolicies = createSelector(
  [selectDomain],
  state => state,
);
